/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProductAdministrationDtoFromDiscriminatorValue, type ProductAdministrationDto } from '../../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../../models/oDataErrors/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the collection of ProductAdministrationDto entities.
 */
export interface WithProductCodeItemRequestBuilder extends BaseRequestBuilder<WithProductCodeItemRequestBuilder> {
    /**
     * Get entity from ProductAdministrationOverview by key
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ProductAdministrationDto>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<WithProductCodeItemRequestBuilderGetQueryParameters> | undefined) : Promise<ProductAdministrationDto | undefined>;
    /**
     * Get entity from ProductAdministrationOverview by key
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithProductCodeItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get entity from ProductAdministrationOverview by key
 */
export interface WithProductCodeItemRequestBuilderGetQueryParameters {
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Select properties to be returned
     */
    select?: string[];
}
/**
 * Uri template for the request builder.
 */
export const WithProductCodeItemRequestBuilderUriTemplate = "{+baseurl}/ProductAdministrationOverview/{productCode}{?%24expand,%24select}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const WithProductCodeItemRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "expand": "%24expand",
    "select": "%24select",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithProductCodeItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithProductCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createProductAdministrationDtoFromDiscriminatorValue,
        queryParametersMapper: WithProductCodeItemRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
